import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import About from './components/About';
import Resume from './components/Resume';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import './assets/css/style.css';

function App() {
    const [activePage, setActivePage] = useState('about');

    const handleNavigation = (page) => {
        console.log(`Navigating to ${page}`);
        setActivePage(page);
    };

    return (
        <main>
            <Sidebar />
            <div className="main-content">
                <Navbar onNavigate={handleNavigation} />
                {activePage === 'about' && <About />}
                {activePage === 'resume' && <Resume />}
                {activePage === 'services' && <Services />}
                {activePage === 'testimonials' && <Testimonials />}
                {activePage === 'contact' && <Contact />}
            </div>
        </main>
    );
}

export default App;
